
import React from 'react';
import { DialogClose } from '@/components/ui/dialog';
import { X } from 'lucide-react';

interface CloseButtonProps {
  canDismiss: boolean;
  onDismiss: () => void;
  isMobile: boolean;
}

const CloseButton: React.FC<CloseButtonProps> = ({ canDismiss, onDismiss, isMobile }) => {
  if (!canDismiss) {
    return (
      <div className="absolute right-4 top-4 rounded-sm opacity-70 cursor-not-allowed">
        <X className="h-4 w-4 text-muted-foreground" />
        <span className="sr-only">Close</span>
      </div>
    );
  }
  
  // For desktop only - mobile drawer doesn't use this button component
  if (!isMobile) {
    return (
      <DialogClose 
        className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
        onClick={onDismiss}
        disabled={!canDismiss}
      >
        <X className="h-4 w-4" />
        <span className="sr-only">Close</span>
      </DialogClose>
    );
  }
  
  // Nothing for mobile as the drawer doesn't use a direct close button
  return null;
};

export default CloseButton;
